import React, { lazy, Suspense } from 'react';
import Loading from '../../../../../Loading';

const LinkedRecordsInTableMode = lazy(() => import('.'));

export const AsyncLinkedRecordsInTableMode = (props) => (
  <Suspense fallback={<Loading />}>
    <LinkedRecordsInTableMode {...props} />
  </Suspense>
);
